import React from "react";
// import flexible from '../../utils/flexible';
import "./index.less";

class ChargeSecurityExplain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    // document.title = '充电安全须知';
    return (
      <div className="page_type_h5_select">
        <div id="chargeExplain">
          <h3>
            为保护用户的合法权益，请您在使本充电设备前务必仔细阅读我们操作规程和安全须知，绿色慧联保留对上述文档进行更新的权利。请您务必按照操作规程和安全须知操作本设备。
          </h3>
          <p>
            一旦开始使用本设备，即视为您已阅读、理解、认可和接受本设备的操作规程和安全须知的全部条款和内容。使用者承诺对自已的行为及因此而产生的所有后果负责。使用者承诺仅出于正当目的使用本设备，并且同意本条款及绿色慧联公司可能制定的任何相关政策或者准则。
          </p>
          <p>
            在使用本设备的过程中，请您务必严格遵守并执行包括但不限于操作规程和安全须知里的要求。对于违反安全须知所提示的使用行为或不可抗因素导致的一切人身伤害、事故、财产损失、法律纠纷，及其他一切造成利益冲突的不利事件，均由用户自己承担相关责任和损失，绿色慧联公司将不承担任何责任。
          </p>
          <h3>安全须知</h3>
          <p>
            (1)
            正确选择充电设备，充电设备与充电车型不匹配可能对车辆安全造成损害，充电设备参数应从远程慧联App或充电桩所属品牌的电官网获知；
          </p>
          <p>
            (2)
            充电前请确认充电设备是否有损坏和异常情况，检查枪头是否干燥、清洁，不可强行插拔充电枪，未结束充电时严禁插拔充电枪；
          </p>
          <p>(3) 充电过程要保证车辆驻停可靠并处于熄火状态，不可随意挪动；</p>
          <p>(4) 充电过程中应确保与充电口安全距离，确保人身安全；</p>
          <p>(5) 紧急状况下按下急停按钮；</p>
          <p>
            (6)
            充电异常时要通过热线电话（400-826-2266）、远程慧联APP等方式反馈，由专业人员进行解决和维修，非专业运营维护人员严禁拆卸充电设备；
          </p>
          <p>
            (7)
            发生火灾、充电设施浸水等事故，严禁靠近充电设备，请及时通知熟悉设备和应急处理方法的人员进行应急处理；
          </p>
          <p>(8) 严禁擅自开启、接线、改造或破坏充电设备，否则存在触电风险；</p>
          <p>
            (9)
            充电时，远程慧联app会将您的以下信息同步到充电桩所属平台：电站编码、充电桩二维码、充电订单号码、用户手机号（手机号信息会依据第三方桩企要求来选择是否同步，默认不同步）、车牌号码、账户余额。
          </p>
        </div>
      </div>
    );
  }
}

export default ChargeSecurityExplain;



// WEBPACK FOOTER //
// ./src/staticPage/chargeSecurityExplain/index.js